"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.breadcrumbSagas = void 0;
var effects_1 = require("redux-saga/effects");
var typescript_string_operations_1 = require("typescript-string-operations");
var BreadcrumbAction_1 = require("@/pages/search/actions/sfilter/BreadcrumbAction");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var RootSearchCallSaga_1 = require("@/pages/search/sagas/RootSearchCallSaga");
var getBreadcrumbTFormat = function (state) { return state.breadcrumb.tFormat; };
var watchOnSetSearchType = function () {
    var searchType, tFormat, lang, t, type, homeText, breadcrumbs;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(BreadcrumbAction_1.default.SET_BREADCRUMB_SEARCH_TYPE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(RootSearchCallSaga_1.getSearchtype)];
            case 2:
                searchType = _a.sent();
                return [4 /*yield*/, effects_1.select(getBreadcrumbTFormat)];
            case 3:
                tFormat = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 4:
                lang = _a.sent();
                t = tFormat;
                type = searchType === SfilterTypeGroup_1.ListingPurposeType.Sale ? t['buy'] : t['rent'];
                homeText = t.homePage;
                breadcrumbs = [
                    { name: homeText, link: "/" + lang },
                    { name: typescript_string_operations_1.String.Format(t['searchPage'], type), action: 'searchPage' },
                ];
                return [4 /*yield*/, effects_1.put(BreadcrumbAction_1.default.setBreadcrumb(breadcrumbs))];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var breadcrumbSagas = {
    watchOnSetSearchType: watchOnSetSearchType,
};
exports.breadcrumbSagas = breadcrumbSagas;
